import { API, axiosInstance } from "lib";


export const profitLossReportList = (data={}) => {
  return axiosInstance
    .post(API.PROFIT_AND_LOSS , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const ownVehicleProfitableList = (data={}) => {
    return axiosInstance
      .post(API.OWN_VEHICLE_PROFITABILITY , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const downloadTripDetailsReports = (data={}) => {
    return axiosInstance
      .post(API.TRIP_DETAILS_REPORT , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };
  
  export const downloadTripRevenueReports = (data={}) => {
    return axiosInstance
      .post(API.TRIP_REVENUE_REPORT , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const generalLedger = (data={}) => {
    return axiosInstance
      .post(API.GENERAL_LEDGER , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const getGeneralLedgerDetails = (data={}) => {
    return axiosInstance
      .post(API.GENERAL_LEDGER_DETAILS_ACCOUNT_TRANSACTIONS , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const getJournalReport = (data={}) => {
    return axiosInstance
      .post(API.JOURNAL_REPORT_LEDGER , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const getBalanceReport = (data={}) => {
    return axiosInstance
      .post(API.BALANCE_REPORT , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const getHorizontalBalanceSheetReport = (data={}) => {
    return axiosInstance
      .post(API.BALANCE_REPORT , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };

  export const getPLR = (data={}) => {
    return axiosInstance
      .post(API.P_AND_L_REPORT , data)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        if (err) {
          console.log(err);
        }
  //      throw err;
      });
  };